module.exports = __webpack_public_path__ + "static/media/rech.4b810efb.jpg";